export const mockFetchShipToForTransactionAccount = {
  pageInfo: {
    endCursor: 'a1ea73bc-751e-4e59-ba19-842c24a086f6',
    hasNextPage: true,
  },
  totalCount: 10,
  nodes: [
    {
      name: 'Test shipto Services',
      id: 'ship-to-party-id',
      addressLine1: '20 Cooper Square',
      addressLine2: 'line 2',
      city: 'NY',
      state: 'NY',
      country: 'US',
      postcode: '10005',
      taxId: null,
      priceEligibility: null,
    },
  ],
};

export const mockFetchShipToForTransactionAccountWithTaxExempt = {
  pageInfo: {
    endCursor: 'a1ea73bc-751e-4e59-ba19-842c24a086f6',
    hasNextPage: true,
  },
  totalCount: 10,
  nodes: [
    {
      name: '',
      id: 'a1ea73bc-751e-4e59-ba19-842c24a08679',
      addressLine1: '20 Cooper Square',
      addressLine2: null,
      city: 'NY',
      state: 'NY',
      country: 'US',
      postcode: '10005',
      taxId: '1244555',
      taxExempt: true,
      priceEligibility: null,
      hasLinkedSubscriptions: true,
    },
  ],
};

export const mockFetchShipToForTxaWithTaxExemptMultiTaxIds = {
  pageInfo: {
    endCursor: 'a1ea73bc-751e-4e59-ba19-842c24a086f6',
    hasNextPage: true,
  },
  totalCount: 10,
  nodes: [
    {
      name: 'Test shipto Services',
      id: 'a1ea73bc-751e-4e59-ba19-842c24a08679',
      addressLine1: '20 Cooper Square',
      addressLine2: null,
      city: 'NY',
      state: 'NY',
      country: 'US',
      postcode: '10005',
      taxId: '1244555',
      taxIds: [
        {
          label: 'vatNumber',
          id: '1244555',
          taxExempt: true,
        },
      ],
      taxLabels: [
        {
          taxIdLabels: [
            {
              displayName: 'PST',
              type: 'vatNumber',
            },
          ],
        },
      ],
      taxExempt: true,
      priceEligibility: 'open_source',
    },
  ],
};

export const mockFetchShipToForTxaWithNoTaxExemptMultiTaxIds = {
  pageInfo: {
    endCursor: 'a1ea73bc-751e-4e59-ba19-842c24a086f6',
    hasNextPage: true,
  },
  totalCount: 10,
  nodes: [
    {
      name: 'Test shipto Services',
      id: 'a1ea73bc-751e-4e59-ba19-842c24a08679',
      addressLine1: '20 Cooper Square',
      addressLine2: null,
      city: 'NY',
      state: 'NY',
      country: 'US',
      postcode: '10005',
      taxId: '1244555',
      taxIds: [
        {
          label: 'vatNumber',
          id: '1244555',
          taxExempt: false,
        },
      ],
      taxLabels: [
        {
          taxIdLabels: [
            {
              displayName: 'PST',
              type: 'vatNumber',
            },
          ],
        },
      ],
      taxExempt: false,
      priceEligibility: 'commercial',
    },
  ],
};

export const mockFetchShipToForTxaWithNoLabelIdInMultiTaxIds = {
  ...mockFetchShipToForTxaWithNoTaxExemptMultiTaxIds,
  nodes: [
    {
      ...mockFetchShipToForTxaWithNoTaxExemptMultiTaxIds['nodes'][0],
      taxIds: [
        {
          label: 'wrong-label',
          id: '1244555',
          taxExempt: false,
        },
      ],
    },
  ],
};

export const mockFetchShipToForTxaWithNoDisplayNameInMultiTaxIds = {
  ...mockFetchShipToForTxaWithNoTaxExemptMultiTaxIds,
  nodes: [
    {
      ...mockFetchShipToForTxaWithNoTaxExemptMultiTaxIds['nodes'][0],
      taxLabels: [
        {
          taxIdLabels: [
            {
              displayName: null,
              type: 'vatNumber',
            },
          ],
        },
      ],
    },
  ],
};

const shipToPartyAstraClub1 = {
  name: 'Astra Club',
  id: 'c1ae8287-3020-4e47-bbe8-52855b7ef3e7',
  addressLine1: 'ASD Tower',
  addressLine2: 'Brigade Metropolis',
  city: 'Bangalore',
  state: 'KA',
  country: 'IN',
  postcode: '560001',
  taxId: '24ABBCC1206D1ZM',
  taxIds: [
    {
      id: '24ABBCC1206D1ZM',
      label: 'vatNumber',
      metadata: {
        vatStatus: null,
      },
      taxExempt: true,
    },
  ],
  taxLabels: [
    {
      region: 'XX',
      taxIdLabels: [
        {
          description: 'Value-added tax - Taxpayer Identification number',
          displayName: 'GST IN',
          type: 'vatNumber',
          metadata: null,
        },
      ],
    },
  ],
};
const shipToPartyAstraClub2 = {
  name: 'Astra Club',
  id: '12124asd-3020-4e47-bbe8-52855b7ef3e7',
  addressLine1: 'ASD Tower',
  addressLine2: 'Brigade Metropolis',
  city: 'Bangalore',
  state: 'KA',
  country: 'IN',
  postcode: '786512',
  taxId: '34ABBCC1206D1ZM',
  taxIds: [
    {
      id: '24ABBCC1206D1ZM',
      label: 'vatNumber',
      metadata: {
        vatStatus: null,
      },
      taxExempt: true,
    },
  ],
  taxLabels: [
    {
      region: 'XX',
      taxIdLabels: [
        {
          description: 'Value-added tax - Taxpayer Identification number',
          displayName: 'GST IN',
          type: 'vatNumber',
          metadata: null,
        },
      ],
    },
  ],
};
export const shipToPartyAstraLtd = {
  name: 'Astra Ltd.',
  id: 'b14ab42d-1d0d-4dc7-b62e-2960b95994e3',
  addressLine1: 'Partners Boulevard',
  addressLine2: 'Solutions Street line 2',
  city: 'Bangalore',
  state: 'KA',
  country: 'IN',
  postcode: '560078',
  taxId: '18AAGHU9603R1ZM',
  priceEligibility: 'commercial',
  taxIds: [
    {
      id: '18AAGHU9603R1ZM',
      label: 'vatNumber',
      metadata: {
        vatStatus: null,
      },
      taxExempt: true,
    },
  ],
  taxLabels: [
    {
      region: 'XX',
      taxIdLabels: [
        {
          description: 'Value-added tax - Taxpayer Identification number',
          displayName: 'GST IN',
          type: 'vatNumber',
          metadata: null,
        },
      ],
    },
  ],
};

export const shipToPartyAstraLtd2 = {
  name: 'Astra Ltd.',
  id: 'new-random-id',
  addressLine1: 'Avenue Road',
  addressLine2: 'New Street lane',
  city: 'Bangalore',
  state: 'KA',
  country: 'IN',
  postcode: '560078',
  taxId: '18AAGHU9603R1ZM',
  taxIds: [
    {
      id: '18AAGHU9603R1ZM',
      label: 'vatNumber',
      metadata: {
        vatStatus: null,
      },
      taxExempt: true,
    },
  ],
  taxLabels: [
    {
      region: 'XX',
      taxIdLabels: [
        {
          description: 'Value-added tax - Taxpayer Identification number',
          displayName: 'GST IN',
          type: 'vatNumber',
          metadata: null,
        },
      ],
    },
  ],
};

export const mockFetchShipToForTxaGrouped = {
  totalCount: 10,
  nodes: [
    {
      key: 'Astra Club',
      data: [shipToPartyAstraClub1, shipToPartyAstraClub2],
    },
    {
      key: 'Astra Ltd.',
      data: [shipToPartyAstraLtd],
    },
  ],
};

export const mockAggregatedShipToParties = {
  totalCount: 10,
  nodes: [
    {
      key: 'Astra Club',
      totalCount: 2,
      data: [],
    },
    {
      key: 'Astra Ltd.',
      totalCount: 1,
      data: [shipToPartyAstraLtd],
    },
  ],
};

export const mockAggregatedShipToParties2 = {
  totalCount: 1,
  nodes: [
    {
      key: 'Astra Ltd.',
      totalCount: 2,
      data: [],
    },
  ],
};

export const mockFetchShipToPartiesForTransactionAccountPPC = {
  transactionAccount: {
    id: 'txa-id',
    shipToParty: {
      nodes: [shipToPartyAstraClub1, shipToPartyAstraClub2],
    },
  },
};

export const mockInvoiceGroupsCountForShipToPartyNames = {
  invoiceGroupsCountForShipToPartyNames: [
    {
      shipToPartyIds: [1, 2],
      shipToPartyName: 'Astra Club',
      totalCount: 2,
    },
    {
      shipToPartyIds: [3],
      shipToPartyName: 'Astra Ltd.',
      totalCount: 1,
    },
  ],
};

export const mockInvoiceGroupsForShipToPartyNames = {
  transactionAccount: {
    billingProfiles: {
      nodes: [
        {
          id: 'invoice-group-id',
          name: 'Billing Profile one',
          invoiceGroupNumber: 'IG-42K7-KP2C-V9AU',
          shipToParty: {
            addressLine1: 'Avenue Road',
            addressLine2: 'New Street lane',
            city: 'Bangalore',
            state: 'KA',
            country: 'IN',
            postcode: '560078',
            taxId: '18AAGHU9603R1ZM',
          },
        },
      ],
    },
  },
};

export const mockEntitlemtCountsForInvoiceGroups = {
  entitlementCountsForInvoiceGroupIds: [
    {
      invoiceGroupId: 'invoice-group-id',
      totalEntitlementsCount: 2,
    },
  ],
};

export const mockCustomerContacts = {
  contactsByResource: [
    {
      accountId: '612fb95cbe9e4d006960d386',
      contactType: 'CUSTOMER_CONTACT',
      email: 'test-ecc-1@atlassian.com',
      name: 'test-ecc-1',
      picture:
        'https://secure.gravatar.com/avatar/3410c9fd752cca233531cd5e8fa31990?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FAS-3.png',
    },
    {
      accountId: '712020:3e671b2f-bd23-4abe-a5ae-67f9cf269980',
      contactType: 'CUSTOMER_CONTACT',
      email: 'test-ecc-2@atlassian.com',
      name: 'test-ecc-2',
      picture:
        'https://secure.gravatar.com/avatar/671f68d3dee73a772c68664887226cbe?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FT-3.png',
    },
  ],
};
